import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import MerchantDetailTopBar from "./Ops.Merchants.MerchantDetailTopBar";
import AllMerchantRatesContainer from "app/components/AppComponents/Merchants/MerchantRates/AllMerchantRatesContainer";
import Paper from "@material-ui/core/Paper";

class Rates extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.props.setBreadCrumbs([
      { title: "SnapScan Ops" },
      { title: "Merchants", link: "/snapscan/ops/merchants" },
      { title: this.props.match.params.id, class: "crumbOverflow" },
      { title: "Rates" },
    ]);
    this.loadData();
  }

  loadData() {
    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.merchant });
        this.props.setHeader({
          title: `Ops > ${fetchMoreResult.merchant.name}`,
          description: "Merchant summary",
        });
      },
    });
  }

  render() {
    const merchant = this.state.data;

    const content = () => {
      if (merchant instanceof Array) return <div></div>;

      const dynamic_rate_emoji =
        merchant.dynamic_rate_enabled === merchant.merchant_rate.dynamic
          ? merchant.dynamic_rate_enabled
            ? "✅"
            : "❌"
          : "🔃";
      const dynamic_rate_text =
        merchant.dynamic_rate_enabled !== merchant.merchant_rate.dynamic
          ? " (subject to enabling during next calculation)"
          : "";
      const current_rate = merchant.current_rate;

      return (
        <div>
          <Paper
            elevation={1}
            style={{
              margin: "10px",
              padding: "10px",
              display: "inline-block",
              width: "calc(100% - 20px)",
            }}
          >
            <span>
              <b>Dynamic Rate</b>
              {": "}
              {`${dynamic_rate_emoji}${
                dynamic_rate_text ? dynamic_rate_text : ""
              }`}
            </span>
            <br />
            <span>
              <b>Current Rate</b>
              {" (incl. VAT): "}
              {`${current_rate}%`}
            </span>
          </Paper>
          {dynamic_stats()}
          <Paper
            elevation={1}
            style={{
              margin: "10px",
              padding: "10px",
              display: "inline-block",
              width: "calc(100% - 20px)",
            }}
          >
            <h3
              style={{
                borderBottom: "1px solid rgb(204, 204, 204)",
                paddingBottom: "10px",
                fontWeight: 100,
              }}
            >
              Historical Rates
            </h3>
            <AllMerchantRatesContainer
              merchantId={this.props.match.params.id}
              name={"ops.merchants.rates.list"}
            />
          </Paper>
        </div>
      );
    };

    const dynamic_stats = () => {
      if (!merchant.dynamic_rate_enabled) return <div></div>;

      const turnover = merchant.turnover_for_month / 100;
      const required_progress = merchant.required_progress / 100;
      const next_tier = merchant.next_tier;

      return (
        <Paper
          elevation={1}
          style={{
            margin: "10px",
            padding: "10px",
            display: "inline-block",
            width: "calc(100% - 20px)",
          }}
        >
          <span>
            <b>Turnover for Month</b>
            {": "}
            {`R ${turnover.toFixed(2)}`}
          </span>
          <br />
          <span>
            <b>Required Progress</b>
            {": "}
            {`R ${required_progress.toFixed(2)}`}
          </span>
          <br />
          <span>
            <b>Next Tier</b>
            {": "}
            {`${next_tier}%`}
          </span>
        </Paper>
      );
    };

    return (
      <React.Fragment>
        <MerchantDetailTopBar />
        <section className="padded scrollable">{content()}</section>
      </React.Fragment>
    );
  }
}

const query = gql`
  query Merchant($id: ID!) {
    merchant(id: $id) {
      name
      current_rate
      turnover_for_month
      dynamic_rate_enabled
      dynamic_rate_floor
      next_tier
      required_progress
      merchant_rate {
        dynamic
        rate
      }
    }
  }
`;

const ratesWithGraphql = graphql(query, {
  options(props: any) {
    return {
      variables: {
        id: props.match.params.id,
      },
    };
  },
})(Rates);

export default ratesWithGraphql;
